export enum UserRole {
  Owner = 0,
  SuperAdmin = 1,
  PolicyAdmin = 2,
  SecurityAdmin = 3,
  Staff = 4,
  UnRole = 5,
}

export const roleToString = (role: UserRole): string => {
  switch (role) {
    case UserRole.Owner:
      return "Owner";
    case UserRole.SuperAdmin:
      return "Super Admin";
    case UserRole.PolicyAdmin:
      return "Policy Admin";
    case UserRole.SecurityAdmin:
      return "Security Admin";
    case UserRole.Staff:
      return "Staff";
    default:
      return "UnRole";
  }
};

export const stringToRole = (role?: string) => {
  switch (role) {
    case "Owner":
      return UserRole.Owner;
    case "Super Admin":
      return UserRole.SuperAdmin;
    case "Policy Admin":
      return UserRole.PolicyAdmin;
    case "Security Admin":
      return UserRole.SecurityAdmin;
    case "Staff":
      return UserRole.Staff;
    default:
      return UserRole.UnRole;
  }
};

export const roleStringList = ["Owner", "Super Admin", "Policy Admin", "Security Admin", "Staff"];
export const roleStringListRemovedOwner = ["Super Admin", "Policy Admin", "Security Admin", "Staff"];

export const allRoles = [
  UserRole.Owner,
  UserRole.SuperAdmin,
  UserRole.PolicyAdmin,
  UserRole.SecurityAdmin,
  UserRole.Staff,
  UserRole.UnRole,
];

export const adminRoles = [UserRole.Owner, UserRole.SuperAdmin, UserRole.PolicyAdmin, UserRole.SecurityAdmin];
export const policyAdminRoles = [UserRole.Owner, UserRole.SuperAdmin, UserRole.PolicyAdmin];
export const securityAdminRoles = [UserRole.Owner, UserRole.SuperAdmin, UserRole.SecurityAdmin];
export const superAdminRoles = [UserRole.Owner, UserRole.SuperAdmin];
export const notUserRoles = [UserRole.UnRole];
